<template>
  <div class="checkbox">
    <div class="outer-box" :key="index" @click="showList($el, $event)" :style="{
      height: this.num + 'px',
      'z-index': this.zindex,
      'background-color': bgcolor,
    }" :class="{
  active: this.num == this.max,
}">
      <div class="list-show">
        {{ checked ? checked : "Reply Recelved" }}
        <img :style="{ display: arr }" src="../assets/images/submit_arrow.png" alt="" />
      </div>
      <div class="list">
        <ul class="list-ul">
          <li class="list-li" @click="choseLiChained(item, index)" v-for="(item, index) in this.li" :key="index"
            :class="{ active: checkedId == index }">
            {{ item.title }}
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props: ["bgcolor", "max", "arr", "li", "zindex", "index", "type"],
  data() {
    return {
      num: "",
      show: "",
      checked: "",
      checkedId: "",
      checkList: ["1"],
      // li: ["li", "Any", "Solving", "Reply Recelved", "Solved"],
    };
  },
  mounted() {
    console.log(this.type);
  },

  methods: {
    choseLi(item, index) {
      this.checked = item;
      this.checkedId = index;
    },
    choseLiChained(item, index) {
      this.checked = item.title;
      this.checkedId = index;
      this.checkList.push(item);
    },
    showList(el, event) {
      // if (!el.contains(event.target)) {            //按钮.app-download以外的区域
      //   this.msgShow = false;
      // }
      if (this.num !== this.max) {
        this.num = this.max;
      } else {
        this.show = "list-item";
        this.num = 46;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/myshowlist.scss";
</style>